export const en = {
    header: {
      business: "Business",
      client: "Client",
    },
    hero: {
      title: "Fast and Reliable Payments for Business and Users",
      subtitle: "Accept cryptocurrency and fiat, instant transactions, complete security",
      businessButton: "Connect Business",
      walletButton: "Create Wallet",
    },
    features: {
      title: "Feennex Advantages",
      items: {
        fastTransactions: {
          title: "Fast Transactions",
          description: "Instant transfers in cryptocurrency and fiat",
        },
        security: {
          title: "Security",
          description: "Protection through multi-level encryption",
        },
        globalReach: {
          title: "Global Reach",
          description: "Working with clients worldwide",
        },
        flexibleSettings: {
          title: "Flexible Settings",
          description: "Adaptation for business and users",
        },
        transparency: {
          title: "Transparency",
          description: "No hidden fees",
        },
        instantSettlement: {
          title: "Instant Settlement",
          description: "Funds available for withdrawal immediately after payment T+0",
        },
      },
    },
    howItWorks: {
      title: "How Feennex Works for Business?",
      steps: {
        createAccount: {
          title: "Create Account",
          description: "Registration and payment cabinet setup",
        },
        connectApi: {
          title: "Connect API",
          description: "Simple integration into your business",
        },
        payments: {
          title: "Send and Receive Payments",
          description: "Instant transfers in cryptocurrency and fiat",
        },
        management: {
          title: "Financial Management",
          description: "Analytics, reports, conversion",
        },
      },
    },
    footer: {
      tagline: "Accept payments in cryptocurrency and fiat",
      contact: "Contact Us",
      service: "Service",
      apiDocs: "API Documentation",
      documents: "Documents",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      copyright: "Copyright © 2025 feennex.com All rights reserved",
    },
    policies: {
      aml: {
        title: "Anti-Money Laundering Policy",
        content: "... AML policy content in English ..."
      },
      privacy: {
        title: "Privacy Policy",
        content: "... Privacy policy content in English ..."
      },
      terms: {
        title: "Terms of Service",
        content: "... Terms of Service content in English ..."
      }
    },
    aml: {
        title: "Anti-Money Laundering Policy",
        content: `<h2>1. Introduction</h2>
                    <p>1.1. This Anti-Money Laundering (AML) Policy outlines Feennex's commitment to preventing money laundering and terrorist financing.</p>
                    <p>1.2. We maintain strict compliance with international AML regulations.</p>

                    <h2>2. Customer Due Diligence</h2>
                    <p>2.1. We implement the following measures:</p>
                    <ul>
                        <li>Customer identification and verification</li>
                        <li>Risk assessment of customers and transactions</li>
                        <li>Ongoing monitoring of transactions</li>
                        <li>Record keeping of all verifications</li>
                    </ul>

                    <h2>3. Risk Assessment</h2>
                    <p>3.1. We assess risks based on:</p>
                    <ul>
                        <li>Customer profile</li>
                        <li>Transaction patterns</li>
                        <li>Geographic location</li>
                        <li>Business relationships</li>
                    </ul>

                    <h2>4. Transaction Monitoring</h2>
                    <p>4.1. We monitor transactions for:</p>
                    <ul>
                        <li>Suspicious patterns</li>
                        <li>Large transactions</li>
                        <li>Unusual activity</li>
                        <li>High-risk indicators</li>
                    </ul>

                    <h2>5. Reporting</h2>
                    <p>5.1. We report suspicious activities to relevant authorities.</p>
                    <p>5.2. We maintain confidentiality of reports and investigations.</p>

                    <h2>6. Staff Training</h2>
                    <p>6.1. Our staff receives regular AML training.</p>
                    <p>6.2. We maintain up-to-date compliance procedures.</p>`
    },
    privacy: {
        title: "Privacy Policy",
        content: `
            <h2>1. Introduction</h2>
            <p>1.1. This Privacy Policy explains how Feennex collects, uses, and protects your personal information.</p>
            <p>1.2. We are committed to ensuring your privacy and protecting your data.</p>

            <h2>2. Information We Collect</h2>
            <p>2.1. We collect the following types of information:</p>
            <ul>
                <li>Personal identification information</li>
                <li>Contact information</li>
                <li>Transaction data</li>
                <li>Usage information</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>3.1. We use your information to:</p>
            <ul>
                <li>Process your transactions</li>
                <li>Provide customer support</li>
                <li>Improve our services</li>
                <li>Comply with legal requirements</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>4.1. We implement strong security measures to protect your data.</p>
            <p>4.2. We use encryption and secure protocols for data transmission.</p>

            <h2>5. Your Rights</h2>
            <p>5.1. You have the right to:</p>
            <ul>
                <li>Access your personal data</li>
                <li>Request data correction</li>
                <li>Request data deletion</li>
                <li>Withdraw consent</li>
            </ul>

            <h2>6. Contact Us</h2>
            <p>6.1. For privacy-related questions, contact us at support@feennex.com</p>
        `
    },
    agreement: {
        title: "Terms of Service",
        content: `
            <h2>1. General Provisions</h2>
            <p>1.1. These Terms of Service govern the relationship between Feennex ("Service") and users regarding the use of the payment processing service.</p>
            <p>1.2. By using our Service, you agree to these terms in full.</p>

            <h2>2. Service Description</h2>
            <p>2.1. Feennex provides payment processing services for cryptocurrency and fiat currency transactions.</p>
            <p>2.2. The service includes but is not limited to:</p>
            <ul>
                <li>Processing cryptocurrency payments</li>
                <li>Fiat currency transactions</li>
                <li>Currency conversion services</li>
                <li>Payment management tools</li>
            </ul>

            <h2>3. User Obligations</h2>
            <p>3.1. Users must:</p>
            <ul>
                <li>Provide accurate information</li>
                <li>Maintain security of their account</li>
                <li>Comply with applicable laws</li>
                <li>Not use the service for illegal activities</li>
            </ul>

            <h2>4. Service Fees</h2>
            <p>4.1. Fee structure is transparent and available in the user dashboard.</p>
            <p>4.2. Fees may be updated with prior notice to users.</p>

            <h2>5. Liability</h2>
            <p>5.1. The service is provided "as is" without warranties.</p>
            <p>5.2. Users are responsible for their transactions and account security.</p>

            <h2>6. Changes to Terms</h2>
            <p>6.1. We may update these terms with notice to users.</p>
            <p>6.2. Continued use after changes constitutes acceptance.</p>
        `
    },
};